import React from 'react'
import AntModal from 'antd/lib/modal'
import { Icon, Icons } from '..'

export const Modal = (props) => <AntModal {...{ closeIcon: <Icon component={Icons.Close} />, ...props }} />

Object.keys(AntModal).forEach((key) => (Modal[key] = AntModal[key]))
